// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__30fOW","label":"Labeled_label__7A8hZ","divider":"Labeled_divider__1KCyC"};